@switch (assetClassification) {
  @case ('DASHBOARD') {
    <app-quicksight-viewer
      [assetId]="assetId"
      [analysisCode]="analysisCode"
      [analysisMetadata]="analysisMetadata"
      [quicksightAssetEmbed]="quickSightDashboard"
      (closeAssetViewer)="onCloseAssetViewer()"
    ></app-quicksight-viewer> 
  }
  @case ('HTML'){
    <app-html-viewer
      [url]="assetContent.content.url"
      [downloadPDFEnabled]="assetContent.downloadEnabled.pdf"
      (closeAssetViewer)="onCloseAssetViewer()"
    ></app-html-viewer>
  }
}
